/* Measure outbound intent without delaying or replacing normal navigation. */
(function () {
  'use strict';
  if (window.bytugbaAmazonTrackingInstalled) return;
  window.bytugbaAmazonTrackingInstalled = true;
  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor) return;
    var destination;
    try { destination = new URL(anchor.href); } catch (_) { return; }
    if (!/(^|\.)amazon\.(com|ca|co\.uk)$/.test(destination.hostname) &&
        destination.hostname !== 'amzn.to') return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        !privacy.analyticsProcessingAllowed()) return;
    var card = anchor.closest('.product-card-wrapper');
    var title = card && card.querySelector('.card__heading');
    var name = title ? title.textContent.trim() : anchor.getAttribute('data-product-name') || '';
    var context = card ? 'product_card' : document.querySelector('.product') ? 'product_page' :
      document.querySelector('article') ? 'blog_article' : 'page_content';
    var parameters = {
      send_to: 'G-2T63CB6MJ7',
      page_path: window.location.pathname,
      link_domain: destination.hostname,
      link_url: destination.origin + destination.pathname,
      cta_location: context,
      product_name: name,
      transport_type: 'beacon'
    };
    if (typeof window.gtag === 'function') window.gtag('event', 'amazon_click', parameters);
    if (typeof window.fbq === 'function') window.fbq('trackCustom', 'AmazonClick', {
      page_path: parameters.page_path, product_name: name, cta_location: context
    });
  });
}());